import { localDayNumber } from './recurrence-dates';

/**
 * ⭐ 2026-10-14 (반복 규칙 F · 사용자 확정) — 반복 회차가 «지난 회차»인가.
 *
 * ```
 * 지난 회차 = 회차 시작의 현지 날짜 < 오늘   (오늘 회차는 지난 회차가 아니다)
 * 이 일정만  지난 회차도 날짜·시간을 바꿀 수 있다(순서 규칙만)
 * 이후 일정  지난 회차에서 열면 날짜·시간·반복을 바꿀 때 «전체»처럼 오늘 이후 일정부터 바뀐다(2026-10-15)
 * 전체 일정  날짜·시간·반복을 바꾸면 지난 회차는 그대로 두고 오늘 이후 일정부터 바뀐다(안내 문구)
 * ```
 * ⚠ 화면은 브라우저 현지 날짜로 미리 가른다 — 서버가 기관 시간대로 최종 판정한다(회사별 내부망 = 시간대 하나).
 * ⚠ 판정의 열쇠는 회차의 «원래 시각»(occurrenceAt)이다 — 서버의 지난 회차 판정과 같은 열쇠.
 */
export function isPastOccurrence(occurrenceAt: string | null | undefined, now: Date = new Date()): boolean {
  if (!occurrenceAt) return false;
  const at = new Date(occurrenceAt);
  if (Number.isNaN(at.getTime())) return false;
  return localDayNumber(at) < localDayNumber(now);
}
